import { render, staticRenderFns } from "./BaseButtonWithIcon.vue?vue&type=template&id=f99057f2"
import script from "./BaseButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports